var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.798 11.005-4.163 4.26.983 6.015a.719.719 0 0 1-.266.686.645.645 0 0 1-.704.053L12.5 19.18l-5.147 2.84a.64.64 0 0 1-.704-.054.719.719 0 0 1-.266-.686l.983-6.015-4.164-4.259a.726.726 0 0 1-.17-.719.68.68 0 0 1 .54-.477l5.755-.877L11.9 3.459c.226-.479.974-.479 1.2 0l2.573 5.473 5.754.877a.68.68 0 0 1 .54.477.726.726 0 0 1-.169.72Z",
    fill: "#EFB920"
  })));
};
export default SvgStar;